'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.error = error;
exports.disable404 = disable404;
exports.show404 = show404;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function error(message) {
    return {
        type: 'error', // для фиксации ошибке не обязательный, но нужный для единообразия экшенов
        show_error: true,
        error: {
            title: "",
            message: message
        }
    };
}

function disable404() {
    return {
        type: 'error',
        disable_404: true
    };
}

function show404() {
    return {
        types: ['fake_request', 'fake_success', 'fake_fail'],
        promise: function promise(client, iBonus) {
            return new _promise2.default(function (resolve, reject) {
                reject('404');
            });
        },
        show_404: true
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/actions/error.js
// module id = 140
// module chunks = 0